// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__o-WSa","title":"AfterBackImages_title__1VX6l","images":"AfterBackImages_images__2xGJW"};